import React from 'react';
import { Badge, Text, Title } from '@mantine/core';
import { When } from '../../common';

import { SurveySourceBadge } from '../SurveySourceBadge';

type Props = {
    sku?: string;
    categoryName?: string;
    description?: string;
    isFromPriceSurvey?: boolean;
    priceSurveyType?: string | null;
    priceSurveyLabel?: string | null;
};

function ProductHeader({
    sku,
    categoryName,
    description,
    isFromPriceSurvey = false,
    priceSurveyType,
    priceSurveyLabel,
}: Props) {
    return (
        <div className="flex flex-col gap-5 rounded-lg shadow-sm bg-white px-6 py-3 mb-5">
            <div>
                <Title order={4}>
                    SKU {sku ? sku.replace(/^0+/, '') : 'N/A'}
                </Title>
                <div className="flex gap-2 mt-2 flex-wrap items-center">
                    <Badge variant="light">{categoryName || 'N/A'}</Badge>
                    <When condition={isFromPriceSurvey}>
                        <SurveySourceBadge
                            isFromPriceSurvey={isFromPriceSurvey}
                            priceSurveyType={priceSurveyType}
                            priceSurveyLabel={priceSurveyLabel}
                            size="md"
                        />
                    </When>
                    <Text className="text-xs text-[#7F7F7F]">
                        {description || 'N/A'}
                    </Text>
                </div>
            </div>
        </div>
    );
}

export default ProductHeader;
